import React, {SVGProps} from 'react';
import {ReactComponent} from '../../assets/svg/dashboard-mobile-icon.svg';

export default (props: SVGProps<any>): JSX.Element => <ReactComponent {...props} />;
